import login_bg from "../assets/images/forgot_bg.webp";
import { Link } from "react-router-dom";
import useAuthStore from "../store/useAuthStore";
import logo from "../assets/images/logo.webp";
import { useEffect } from "react";

const ForgotPassword: React.FC = () => {
    const { email, setEmail, setError, forgotPassword, error, successMessage,setSuccessMessage, isLoading } = useAuthStore();
  
    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
      await forgotPassword();
    };
    useEffect(() => {
        setSuccessMessage(""); // Reset success message when component mounts
        setError(""); 
    }, []);
  return (
    <>
     <nav className="mainHeader  loginheader navbar navbar-expand-lg navbar-light  border-bottom">
        <div className="container">
            <a className="navbar-brand" href="index.html">
               <Link to="/"><img src={logo} alt="" className="img-fluid" /> </Link>
            </a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse customNav" id="navbarNav">

                <div className="d-flex ms-auto align-items-center auth_wrapper">
                <Link to="/signup"><button className="btn btn-outline-primary">Join Now For Free</button></Link>
                </div>
            </div>
        </div>
    </nav>
    <section className="auth_hero_wrapper position-relative bg-light pt-4 ">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 pe-0">
                    <div className="auth_hero_inner_img" style={{ backgroundImage: `url(${login_bg})` }}>

                    </div>
                </div>
                {successMessage ? 
                <div className="col-lg-5 ps-lg-0 offset-lg-1">
                    <div className="auth_caption">
                        <h2 className="text-dark mb-4">Reset your Password</h2>
                        <div className="my-4 border-bottom"></div>
                        <h5 className="mb-4">If that is a registered slammmm email address you will receive a password reset
                            email very soon, otherwise please try a different email. Remember to check your Junk email
                            folder!
                        </h5>

                       <Link to="/login"><button className="btn btn-primary w-100">Retun to Sign in</button></Link> 


                    </div>
                </div>
                :
                <div className="col-lg-5 ps-lg-0 offset-lg-1">
                    <div className="auth_caption">
                        <h2 className="text-dark mb-4">Password Recovery</h2>
                        <div className="my-4 border-bottom"></div>
                        <h5 className="mb-4">We'll email you instructions for resetting your password.
                        </h5>
                        <form className="auth_form mb-4">
                            <input
                                className="form-control "
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                               
                                />
                                   {error && <p style={{ color: "red" }}>{error}</p>}
                                   {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
                        </form>
                        <a href="#" className="btn btn-primary w-100" onClick={handleSubmit}>{isLoading ? "Sending..." : "Reset Password"}</a>
                        <div className="text-center mt-4">
                            <Link to="/login" className="text-decoration-none text-dark font600"><i
                                    className="fa-solid fa-arrow-left me-2"></i> Back to Sign
                                in</Link>
                        </div>

                    </div>
                </div>
                }

            </div>
        </div>
    </section>

  
  
    </>
  
  );
};

export default ForgotPassword;
